import styled, { css } from 'styled-components'
import { palette, theme, ifProp, ifNotProp, withProp } from 'styled-tools'
import media from 'styled-media-query'

import getBgColor from '../../../utils/styling/backgroundOptions'

export const Wrapper = styled.div`
  width: 100%;  
  background-color: ${withProp('isInverse', getBgColor)};
  text-align: center;
  margin-top:-1px;

  padding: ${theme('sizes.vAtomMarginRibbon')};
  ${media.lessThan('small')`
      padding:0;
  `};

  p {
    margin: 0;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  a {
    color: ${palette('action')};
    text-decoration: none;
    display: flex;
    margin-left: 6px;
    align-items: center;

    &:after {
      margin-left: 4px;
      content: url('/icons/arrow_right_yoco_blue.svg');
    }
  }


  ${ifNotProp(
    'isPresent',
    css`
      display: none;
      /* top: -10px; */
    `
  )}

  ${ifProp(
    'isInverse',
    css`
      background-color: ${palette('black')};
      color: ${palette('white')};

      p {
        color: ${palette('white')};
      }

      a {
        color: ${palette('action')};
      }
    `
  )}

  /* FIXME: Covid= hack */
  ${ifProp(
    'isBlue',
    css`
      background-color: ${palette('action')};
      color: ${palette('white')};

      a {
        color: ${palette('white')};
        text-decoration: none;

        &:after {
          margin-left: 4px;
          content: url('/icons/arrow_right_yoco_white.svg');
        }
      }
    `
  )}

  ${ifProp(
    'isSticky',
    css`
      position: fixed;
      left: 0;
      right: 0;
      z-index: ${theme('zIndex.float')};
    `
  )}

  /* TRANSITION - Fade in */
	opacity: 1;
	animation-name: fadeInOpacity;
	animation-iteration-count: 1;
	animation-timing-function: ease-in;
	animation-duration: 500ms;

  @keyframes fadeInOpacity {
    0% {
      opacity: 0;
    }
    100% {
      opacity: 1;
    }
  }

`

export const Container = styled.div`
  display: flex;
  margin: auto;
  max-width: ${theme('sizes.containerFixed')};
  padding-left: ${theme('sizes.hBleed')};
  padding-right: ${theme('sizes.hBleed')};
`

export const ContentSection = styled.section`
  display: flex;
  align-items: center;
  justify-content: flex-start;
  flex: 1 0 auto;
  font-size: ${theme('typography.size.reference')};

  /* FIXME: Covid= hack */
  &[role='button'] {
    cursor: pointer;
  }

  ${media.greaterThan('small')`
    justify-content: center;
  `};
`

export const DismissBtn = styled.div`
  padding: 10px;
  color: ${palette('text')};
  display: flex;
  align-items: center;
  justify-content: flex-end;

  &:after {
    margin-left: 4px;
    content: '';
  }

  ${media.greaterThan('small')`
  padding: ${theme('sizes.vAtomMarginRibbon')};
  `};

  &:hover {
    cursor: pointer;
  }

  ${ifProp(
    'isInverse',
    css`
      color: ${palette('textInverse')};
    `
  )};
`

export default Wrapper



// WEBPACK FOOTER //
// ./includes/yoco-website-cms-gatsby/src/components/element/Ribbon/styled.js